const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1743",
    d: "M17.9937 3.79099L13.1363 10.0281C12.9046 10.3256 13.0731 10.7627 13.4446 10.8278L16.8901 11.4311C17.3469 11.5111 17.4581 12.116 17.0597 12.3532L5.54249 19.2108C5.13449 19.4538 4.64938 19.0445 4.82013 18.6014L7.27547 12.23C7.38871 11.9361 7.20536 11.612 6.89515 11.5577L3.07238 10.8883C2.74587 10.8311 2.56436 10.4778 2.70802 10.1791L6.89544 1.47171C6.99246 1.26996 7.21176 1.15729 7.43228 1.1959L17.6855 2.99127C18.057 3.05631 18.2255 3.49347 17.9937 3.79099Z",
    fill: "#C1EC18",
    style: {
      fill: "#C1EC18",
      fill: "color(display-p3 0.7585 0.9250 0.0925)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1743 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3883 4.09791L13.5309 10.335L16.9764 10.9383C17.89 11.0983 18.1125 12.308 17.3155 12.7825L5.79836 19.6402C4.98235 20.126 4.01214 19.3075 4.35364 18.4213L6.80898 12.0499L2.98621 11.3805C2.33318 11.2661 1.97016 10.5595 2.25748 9.96208L6.4449 1.25471C6.63895 0.851203 7.07756 0.625862 7.51858 0.703087L17.7718 2.49845C18.5147 2.62854 18.8517 3.50287 18.3883 4.09791ZM13.1364 10.0278L17.9938 3.79069C18.2255 3.49317 18.057 3.056 17.6856 2.99096L7.43234 1.19559C7.21183 1.15698 6.99253 1.26965 6.8955 1.4714L2.70809 10.1788C2.56442 10.4775 2.74593 10.8308 3.07245 10.888L6.89522 11.5574C7.20543 11.6117 7.38878 11.9358 7.27554 12.2297L4.8202 18.6011C4.64945 19.0442 5.13455 19.4535 5.54256 19.2105L17.0597 12.3529C17.4582 12.1157 17.347 11.5108 16.8902 11.4308L13.4446 10.8275C13.0732 10.7624 12.9047 10.3253 13.1364 10.0278Z",
    fill: "#384B00",
    style: {
      fill: "#384B00",
      fill: "color(display-p3 0.2196 0.2941 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1751",
    d: "M6.89549 1.47181C6.99252 1.27006 7.21182 1.15739 7.43234 1.196L11.5161 1.91108L8.33881 8.66089L3.84009 7.82527L6.89549 1.47181Z",
    fill: "#D1FA2D",
    style: {
      fill: "#D1FA2D",
      fill: "color(display-p3 0.8184 0.9792 0.1754)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1747 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8232 12.1315C7.95122 12.1833 8.01308 12.329 7.96136 12.457L5.43011 18.7226C5.37839 18.8506 5.23268 18.9125 5.10466 18.8608C4.97664 18.8091 4.91479 18.6633 4.96651 18.5353L7.49776 12.2697C7.54948 12.1417 7.69518 12.0798 7.8232 12.1315Z",
    fill: "#E8FF8C",
    style: {
      fill: "#E8FF8C",
      fill: "color(display-p3 0.9100 1.0000 0.5500)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1745",
    d: "M17.0596 12.3526L5.54248 19.2102L14.7013 11.5201L14.4481 11.0117L16.8901 11.4304C17.3469 11.5104 17.4581 12.1153 17.0596 12.3526Z",
    fill: "#76AC05",
    style: {
      fill: "#76AC05",
      fill: "color(display-p3 0.4627 0.6745 0.0196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1746",
    d: "M17.9939 3.7903L13.1365 10.0274C12.9057 10.3237 13.0719 10.7585 13.4402 10.8263L10.9482 10.3789L15.6983 2.64258L17.6856 2.99057C18.0571 3.05562 18.2256 3.49278 17.9939 3.7903Z",
    fill: "#76AC05",
    style: {
      fill: "#76AC05",
      fill: "color(display-p3 0.4638 0.6750 0.0197)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1749 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86589 19.5923C5.84475 19.6103 5.82215 19.6264 5.79833 19.6406C4.98233 20.1265 4.01211 19.308 4.35362 18.4218L6.80895 12.0503L2.98618 11.3809C2.33315 11.2666 1.97013 10.56 2.25746 9.96252L6.44487 1.25515C6.63892 0.851645 7.07753 0.626304 7.51856 0.703529L15.0595 2.02396C15.755 2.14575 16.1086 2.93049 15.7392 3.53221L11.7567 10.0185L14.1219 10.4485C14.9528 10.5996 15.2339 11.6489 14.5898 12.1951L5.86589 19.5923ZM14.0325 10.9405C14.4479 11.016 14.5885 11.5407 14.2664 11.8137L5.54253 19.211C5.13453 19.4539 4.64942 19.0447 4.82017 18.6016L7.27551 12.2301C7.38875 11.9362 7.2054 11.6121 6.89519 11.5578L3.07242 10.8884C2.74591 10.8312 2.5644 10.4779 2.70806 10.1792L6.89548 1.47185C6.9925 1.27009 7.2118 1.15742 7.43232 1.19604L14.9732 2.51647C15.321 2.57736 15.4978 2.96973 15.3131 3.27059L10.9482 10.3797L14.0325 10.9405Z",
    fill: "#384B00",
    style: {
      fill: "#384B00",
      fill: "color(display-p3 0.2196 0.2941 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1750",
    d: "M10.9482 10.3792L15.3132 3.27013C15.4979 2.96926 15.3211 2.57689 14.9733 2.516L14.0732 2.3584L10.0732 10.1292L10.9482 10.3792Z",
    fill: "#94D609",
    style: {
      fill: "#94D609",
      fill: "color(display-p3 0.5789 0.8375 0.0349)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1748 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30737 1.65401C7.43161 1.71425 7.48349 1.86379 7.42325 1.98803L3.42325 10.238C3.36302 10.3623 3.21347 10.4142 3.08923 10.3539C2.96499 10.2937 2.91311 10.1441 2.97335 10.0199L6.97335 1.76989C7.03358 1.64566 7.18313 1.59377 7.30737 1.65401Z",
    fill: "#E8FF8C",
    style: {
      fill: "#E8FF8C",
      fill: "color(display-p3 0.9100 1.0000 0.5500)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1742 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43237 7.5837C4.55661 7.64393 4.60849 7.79348 4.54825 7.91772L3.42325 10.238C3.36302 10.3623 3.21347 10.4142 3.08923 10.3539C2.96499 10.2937 2.91311 10.1441 2.97335 10.0199L4.09835 7.69958C4.15858 7.57534 4.30813 7.52346 4.43237 7.5837Z",
    fill: "#F5FFE0",
    style: {
      fill: "#F5FFE0",
      fill: "color(display-p3 0.9613 1.0000 0.8792)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 821",
    d: "M15.0565 6.73409C15.0059 6.84618 14.8884 6.90255 14.794 6.85998C14.6996 6.81741 14.6641 6.69202 14.7146 6.57992C14.7652 6.46783 14.8827 6.41146 14.9771 6.45403C15.0715 6.4966 15.107 6.62199 15.0565 6.73409Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 827",
    d: "M14.3565 8.04561C14.306 8.15771 14.1885 8.21407 14.0941 8.1715C13.9997 8.12893 13.9641 8.00355 14.0147 7.89145C14.0652 7.77935 14.1827 7.72299 14.2771 7.76556C14.3715 7.80813 14.4071 7.93351 14.3565 8.04561Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 826",
    d: "M14.4983 7.27153C14.4293 7.4245 14.269 7.50142 14.1402 7.44333C14.0114 7.38523 13.9628 7.21413 14.0318 7.06116C14.1008 6.90819 14.2612 6.83127 14.39 6.88937C14.5188 6.94746 14.5673 7.11856 14.4983 7.27153Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 822",
    d: "M16.0018 5.7419C15.9512 5.854 15.8337 5.91036 15.7393 5.86779C15.6449 5.82522 15.6094 5.69984 15.6599 5.58774C15.7105 5.47564 15.828 5.41928 15.9224 5.46185C16.0168 5.50442 16.0523 5.6298 16.0018 5.7419Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 823",
    d: "M15.3537 5.90985C15.3175 5.99007 15.2334 6.0304 15.1659 5.99994C15.0983 5.96948 15.0729 5.87975 15.1091 5.79954C15.1452 5.71932 15.2293 5.67899 15.2969 5.70945C15.3644 5.73992 15.3899 5.82964 15.3537 5.90985Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 824",
    d: "M15.5983 6.51141C15.5621 6.59163 15.478 6.63196 15.4105 6.6015C15.343 6.57104 15.3175 6.48132 15.3537 6.4011C15.3899 6.32089 15.4739 6.28055 15.5415 6.31102C15.609 6.34148 15.6345 6.4312 15.5983 6.51141Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 825",
    d: "M14.8341 7.54266C14.798 7.62288 14.7139 7.66321 14.6463 7.63275C14.5788 7.60229 14.5534 7.51257 14.5895 7.43235C14.6257 7.35214 14.7098 7.3118 14.7773 7.34227C14.8449 7.37273 14.8703 7.46245 14.8341 7.54266Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 828",
    d: "M13.631 8.39325C13.5948 8.47347 13.5108 8.5138 13.4432 8.48334C13.3757 8.45287 13.3502 8.36315 13.3864 8.28294C13.4226 8.20272 13.5067 8.16239 13.5742 8.19285C13.6418 8.22331 13.6672 8.31304 13.631 8.39325Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 829",
    d: "M14.8341 6.0202C14.798 6.10042 14.7139 6.14075 14.6463 6.11029C14.5788 6.07983 14.5534 5.99011 14.5895 5.90989C14.6257 5.82968 14.7098 5.78934 14.7773 5.81981C14.8449 5.85027 14.8703 5.93999 14.8341 6.0202Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 830",
    d: "M15.5983 4.7702C15.5621 4.85042 15.478 4.89075 15.4105 4.86029C15.343 4.82983 15.3175 4.7401 15.3537 4.65989C15.3899 4.57968 15.4739 4.53934 15.5415 4.56981C15.609 4.60027 15.6345 4.68999 15.5983 4.7702Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 831",
    d: "M16.5671 4.92645C16.5309 5.00667 16.4468 5.047 16.3793 5.01654C16.3117 4.98608 16.2863 4.89635 16.3224 4.81614C16.3586 4.73593 16.4427 4.69559 16.5102 4.72606C16.5778 4.75652 16.6032 4.84624 16.5671 4.92645Z",
    fill: "#598400",
    style: {
      fill: "#598400",
      fill: "color(display-p3 0.3502 0.5167 0.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1752 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9632 11.2987C14.0549 11.4019 14.0457 11.5599 13.9425 11.6517L9.14562 15.9173C9.04245 16.009 8.88443 15.9998 8.79268 15.8966C8.70093 15.7934 8.71019 15.6354 8.81337 15.5437L13.6102 11.278C13.7134 11.1863 13.8714 11.1955 13.9632 11.2987Z",
    fill: "#B2D917",
    style: {
      fill: "#B2D917",
      fill: "color(display-p3 0.6984 0.8500 0.0921)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1753 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4357 2.42129C13.559 2.48338 13.6087 2.63368 13.5466 2.75701L10.1403 9.52263C10.0783 9.64596 9.92795 9.6956 9.80462 9.63351C9.6813 9.57142 9.63166 9.42111 9.69375 9.29779L13.1 2.53216C13.1621 2.40884 13.3124 2.3592 13.4357 2.42129Z",
    fill: "#B2D917",
    style: {
      fill: "#B2D917",
      fill: "color(display-p3 0.6984 0.8500 0.0921)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 832",
    d: "M12.1083 11.5233C12.0716 11.6564 11.9474 11.7383 11.8309 11.7062C11.7145 11.6741 11.6498 11.5401 11.6865 11.407C11.7232 11.2739 11.8473 11.192 11.9638 11.2241C12.0803 11.2563 12.145 11.3902 12.1083 11.5233Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 833",
    d: "M11.3337 12.4617C11.3088 12.5523 11.2243 12.608 11.1451 12.5861C11.0659 12.5643 11.0219 12.4732 11.0469 12.3827C11.0718 12.2921 11.1563 12.2365 11.2355 12.2583C11.3147 12.2801 11.3587 12.3712 11.3337 12.4617Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 840",
    d: "M10.3423 12.9266C10.3173 13.0171 10.2329 13.0728 10.1536 13.051C10.0744 13.0291 10.0304 12.938 10.0554 12.8475C10.0804 12.757 10.1648 12.7013 10.244 12.7231C10.3232 12.745 10.3672 12.8361 10.3423 12.9266Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 834",
    d: "M11.3337 11.5135C11.3088 11.604 11.2243 11.6597 11.1451 11.6379C11.0659 11.616 11.0219 11.525 11.0469 11.4344C11.0718 11.3439 11.1563 11.2882 11.2355 11.31C11.3147 11.3319 11.3587 11.423 11.3337 11.5135Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 835",
    d: "M12.99 11.3299C12.965 11.4204 12.8806 11.4761 12.8013 11.4543C12.7221 11.4325 12.6781 11.3414 12.7031 11.2508C12.7281 11.1603 12.8125 11.1046 12.8917 11.1265C12.9709 11.1483 13.0149 11.2394 12.99 11.3299Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 836",
    d: "M12.2752 12.011C12.2578 12.0744 12.1986 12.1134 12.1431 12.0981C12.0876 12.0828 12.0568 12.019 12.0743 11.9556C12.0918 11.8922 12.1509 11.8532 12.2064 11.8685C12.2619 11.8838 12.2927 11.9476 12.2752 12.011Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 837",
    d: "M10.7987 13.261C10.7812 13.3244 10.722 13.3634 10.6666 13.3481C10.6111 13.3328 10.5803 13.269 10.5977 13.2056C10.6152 13.1422 10.6744 13.1032 10.7299 13.1185C10.7853 13.1338 10.8161 13.1976 10.7987 13.261Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 841",
    d: "M11.0333 10.9427C11.0158 11.0061 10.9567 11.0451 10.9012 11.0298C10.8457 11.0145 10.8149 10.9507 10.8324 10.8873C10.8498 10.8239 10.909 10.7849 10.9645 10.8002C11.02 10.8155 11.0508 10.8793 11.0333 10.9427Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 842",
    d: "M12.4762 11.1155C12.4587 11.1789 12.3995 11.2179 12.344 11.2026C12.2886 11.1873 12.2578 11.1235 12.2752 11.0601C12.2927 10.9967 12.3519 10.9577 12.4073 10.973C12.4628 10.9883 12.4936 11.0521 12.4762 11.1155Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 843",
    d: "M11.8526 12.2093C11.8351 12.2727 11.776 12.3117 11.7205 12.2964C11.665 12.2811 11.6342 12.2173 11.6517 12.1539C11.6692 12.0905 11.7283 12.0515 11.7838 12.0668C11.8393 12.0821 11.8701 12.1459 11.8526 12.2093Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 844",
    d: "M10.7987 11.6643C10.7812 11.7278 10.722 11.7668 10.6666 11.7515C10.6111 11.7362 10.5803 11.6724 10.5977 11.609C10.6152 11.5455 10.6744 11.5065 10.7299 11.5218C10.7853 11.5371 10.8161 11.6009 10.7987 11.6643Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 838",
    d: "M10.9701 12.0667C10.9526 12.1301 10.8934 12.1691 10.8379 12.1538C10.7825 12.1385 10.7517 12.0747 10.7691 12.0113C10.7866 11.9479 10.8458 11.9089 10.9012 11.9242C10.9567 11.9395 10.9875 12.0033 10.9701 12.0667Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 839",
    d: "M9.94857 13.9104C9.93109 13.9738 9.87194 14.0129 9.81646 13.9976C9.76097 13.9823 9.73017 13.9185 9.74765 13.855C9.76513 13.7916 9.82428 13.7526 9.87976 13.7679C9.93524 13.7832 9.96605 13.847 9.94857 13.9104Z",
    fill: "#E6FF84",
    style: {
      fill: "#E6FF84",
      fill: "color(display-p3 0.9033 1.0000 0.5167)",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementIcon);
export default __webpack_public_path__ + "static/media/engagement-icon.028fe4471b341d76aec54c9a6715ccb987bad74a02d88f9b249d66ff73d592da.svg";
export { ForwardRef as ReactComponent };